import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { FollowListPage } from "@/features/social/components/follow-list-page";
import { useI18n } from "@/providers/i18n-provider";

function SocialFollowingRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`A quién sigues`)}
      description={t(msg`Inicia sesión para seguir a otros coleccionistas.`)}
    >
      <FollowListPage mode="following" />
    </AuthPlaceholder>
  );
}

export const socialFollowingRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/social/following",
  component: SocialFollowingRoutePage,
});
